module.exports = __webpack_public_path__ + "img/9394864.png";